import React, {useEffect} from 'react';
import Dialog from "@material-ui/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CheckoutForm from "./CheckoutForm";
import {Elements} from "react-stripe-elements";
import routes from "../../../utils/api-client";
import {compose} from "redux";
import {connect} from "react-redux";
import {subscriptionTypeMapping} from "../../../config/constants";
import Tooltip from "@material-ui/core/Tooltip";
import iziToast from "izitoast";
import {openConfirmationModal, toggleLoading} from "../../../redux/reducers/utils";
import ReactGA from 'react-ga';
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FdlOutlinedInput from "../../../utils/FdlOutlinedInput/FdlOutlinedInput";
import Button from "@material-ui/core/Button";


function AccountPreferencesModal(props){

  const [subscriptionPlan, setSubscriptionPlan] = React.useState('ANNUAL');
  const [showCouponCode, setShowCouponCode] = React.useState(false);
  const [couponCode, setCouponCode] = React.useState('');
  const [validCouponCode, setValidCouponCode] = React.useState('');
  const [couponDiscount, setCouponDiscount] = React.useState();
  const [isInvalidCouponCode, setIsInvalidCouponCode] = React.useState(false);

  const useStyles = makeStyles({
    root: {
      // padding: theme.spacing(0),
    },
    accountPreferencesModal: {
      maxWidth: '700px',
    },
    titleText: {
      width: '150px'
    },
    subscriptionContainer: {
      padding: '24px',
      border: '1px solid grey',
      width: '100%'
    }
  });

  useEffect(() => {
  }, [props.open]);

  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setSubscriptionPlan(newValue);
  };

  const cancelSubscription = ()=> {
    props.toggleLoading(true);
    props.onClose();
    routes.cancelSubscription().subscribe(() => {
      // ghetto hack because the Auth0 rule that populates data on signup doesn't fire immediately for some reason.
      // this forces the auth0 token to re-send, which should have user data
      window.location.reload();
    });
  };

  const createSubscription = (token)=> {
    props.toggleLoading(true);
    props.onClose();
    routes.createSubscription(subscriptionPlan, token, validCouponCode).subscribe((response) => {
      if (response.status === 200) {
        props.onClose();
        ReactGA.event({
          category: 'Paid Subscription',
          action: 'click',
          label: `${subscriptionPlan} Signup`,
          value: `${subscriptionPlan} Signup`
        });
        iziToast.success({
          position: "topCenter",
          'title': 'Success',
          'message': 'Your payment has been successfully processed and your subscription to Fidelius is active.'
        });

        // ghetto hack because the Auth0 rule that populates data on signup doesn't fire immediately for some reason.
        // this forces the auth0 token to re-send, which should have user data
        setTimeout(() => window.location.reload(), 2000);
      } else {
        props.toggleLoading(false);
      }
    });
  };

  const getLabelText = (labelType) => {
    switch (labelType) {
      case 'LIFETIME':
        return <p className="ml-2">Lifetime –&nbsp;
          {
            validCouponCode ?
              <>
                <span className="text-grey strike-through-text">$150</span>&nbsp;
                <span className="text-primary font-bold">${(150 * couponDiscount).toFixed(2)}&nbsp;</span>
              </>
              :
              <b>$150&nbsp;</b>
          }
          one-time fee</p>;
      case 'ANNUAL':
        return <p className="ml-2">Annual –&nbsp;
          {
            validCouponCode ?
              <>
                <span className="text-grey strike-through-text">$55</span>&nbsp;
                <span className="text-primary font-bold">${(55 * couponDiscount).toFixed(2)}&nbsp;</span>
              </>
              :
              <b>$55&nbsp;</b>
          }
          per year</p>;
      case 'MONTHLY':
        return <p className="ml-2">Monthly –&nbsp;
          {
            validCouponCode ?
              <>
                <span className="text-grey strike-through-text">$7</span>&nbsp;
                <span className="text-primary font-bold">${(7 * couponDiscount).toFixed(2)}&nbsp;</span>
              </>
              :
              <b>$7&nbsp;</b>
          }
          per month</p>;
    }
  };

  const applyCoupon = () => {
    routes.checkCouponCode(couponCode).subscribe((response) => {
      if (response.status === 200) {
        if (response.data.valid_coupon_code) {
          setValidCouponCode(couponCode);
          setIsInvalidCouponCode(false)
          setCouponDiscount(response.data.coupon_discount)
        } else {
          setValidCouponCode('');
          setIsInvalidCouponCode(true)
          setCouponDiscount(null)
        }
      }
    })
  }

  const activeSubscription = props.user && props.user.subscriptionType !== 'FREE_TRIAL' && props.user.subscriptionStatus !== 'CANCELED';

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth={"md"} className={classes.root}>
      {
        props.user &&
        <div className={classes.accountPreferencesModal}>
          <div className="flex items-center justify-between w-full mb-2">
            <p className="text-2xl font-bold">Account Details</p>
            <FontAwesomeIcon icon="times" size="lg" className="text-grey cursor-pointer" onClick={props.onClose}/>
          </div>
          <Divider/>
          <div className={"sm:flex sm:items-center my-4"}>
            <p className={`sm:mr-4 mb-2 sm:mb-0 text-lg sm:text-base font-bold ${classes.titleText}`}>Email Address</p>
            <p>{ props.user.email }</p>
          </div>
          <Divider className="faded"/>
          <div className={"sm:flex sm:items-center my-4"}>
            <p className={`sm:mr-4 mb-2 sm:mb-0 text-lg sm:text-base font-bold ${classes.titleText}`}>Full Name</p>
            <div className="flex items-center flex-1">
              <p>{ props.user.name }</p>
              <Tooltip enterTouchDelay={50} title="Please contact support at support@fideliusvaults.com or start a chat session to make any changes.">
                <p className="ml-4 text-grey cursor-pointer">(edit)</p>
              </Tooltip>
            </div>
          </div>
          <Divider className="faded"/>
          <div className={"sm:flex sm:items-center my-4"}>
            <p className={`sm:mr-4 mb-2 sm:mb-0 text-lg sm:text-base font-bold ${classes.titleText}`}>Password</p>
            <Tooltip enterTouchDelay={50} title="Please contact support at support@fideliusvaults.com or start a chat session to make any changes.">
              <p className="text-grey cursor-pointer">(change password)</p>
            </Tooltip>
          </div>

          <Divider className="faded"/>
          <div className={`sm:flex my-4 ${activeSubscription ? 'sm:items-center' : ''}`}>
            <p className={`sm:mr-4 mb-2 sm:mb-0 text-lg sm:text-base font-bold ${classes.titleText}`}>Subscription</p>
            {
              activeSubscription ?
                // SHOW SUBSCRIPTION TYPE
                <div className={"flex items-center flex-1"}>
                  <p>{ subscriptionTypeMapping[props.user.subscriptionType] }</p>
                  {
                    props.user.subscriptionType !== 'LIFETIME' &&
                    <a className="text-grey ml-4"
                       onClick={() => props.openConfirmationModal("CANCEL_SUBSCRIPTION", () => cancelSubscription())}>
                      (cancel)</a>
                  }
                </div>
                :
                // SHOW SUBSCRIPTION OPTIONS
                <div className="flex-1">
                  <p className="mb-5">Choose one of the subscription plans below to upgrade your account. For more information,
                    please see our <a target="_blank" href="https://www.fideliusvaults.com/pricing/">Pricing page</a>.</p>

                  <FormControl component="fieldset">
                    {/*<FormLabel component="legend">Subscription Plans</FormLabel>*/}
                    <RadioGroup aria-label="Subscription Plan" name="subscriptionPlan" value={subscriptionPlan}
                                onChange={(event) => setSubscriptionPlan(event.target.value)}>
                      <FormControlLabel value="LIFETIME" control={<Radio/>} label={getLabelText('LIFETIME')}/>
                      <FormControlLabel value="ANNUAL" control={<Radio/>} label={getLabelText('ANNUAL')}/>
                      <FormControlLabel value="MONTHLY" control={<Radio/>} label={getLabelText('MONTHLY')}/>
                    </RadioGroup>
                  </FormControl>
                  <div className="top-spacer-medium flex items-center">
                    <a onClick={() => setShowCouponCode(!showCouponCode)} className="text-secondary">Have a coupon code?</a>
                    <FontAwesomeIcon icon={showCouponCode ? 'caret-down' : 'caret-right'} className="text-secondary ml-2"/>
                  </div>
                  {
                    showCouponCode &&
                    <div className="mt-2 flex flex-col sm:flex-row items-center">
                      <div className="flex items-center">
                        <FdlOutlinedInput width={"200px"}
                                          value={couponCode}
                                          label={""}
                                          hideTopMargin
                                          placeholder={"Coupon Code"}
                                          onChange={(value) => setCouponCode(value)} />
                        <Button
                          variant="outlined"
                          className={"left-spacer"}
                          color={"secondary"}
                          onClick={applyCoupon}
                          disabled={!couponCode}>
                          Apply
                        </Button>
                      </div>

                      {
                        isInvalidCouponCode &&
                        <div className="flex items-center mt-3 sm:mt-0">
                          <FontAwesomeIcon icon="times" className="text-alert left-spacer"/>
                          <p className="left-spacer-small">Invalid Coupon Code</p>
                        </div>
                      }
                      {
                        validCouponCode &&
                        <div className="flex items-center mt-3 sm:mt-0">
                          <FontAwesomeIcon icon="check" className="text-primary left-spacer"/>
                          <p className="left-spacer-small">{((1 - couponDiscount) * 100).toFixed(0)}% off coupon applied</p>
                        </div>
                      }
                    </div>
                  }
                  <div className="mt-5">
                    <Elements>
                      <CheckoutForm createSubscription={createSubscription}/>
                    </Elements>
                  </div>
                </div>
            }
          </div>
        </div>
      }
    </Dialog>
  );
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading, openConfirmationModal }
  )
)(AccountPreferencesModal);